/**
 * Fail-closed permission check for portal menu and route guards.
 * Null, undefined, or empty permissions grant access to nothing.
 */
export const hasPortalPermission = (
  permissions: Permission[] | null | undefined,
  permission: Permission,
): boolean => {
  if (!permissions?.length) return false;
  return permissions.includes(permission);
};

export const hasAnyPortalPermission = (
  permissions: Permission[] | null | undefined,
): boolean => Boolean(permissions?.length);

/** Priority order mirrors SideContent menu (top → bottom, sub-items left → right). */
export const POST_LOGIN_ROUTE_PRIORITY: ReadonlyArray<{
  permission: Permission;
  path: string;
}> = [
  { permission: 'home', path: '/inicio' },
  { permission: 'models', path: '/relatorios/modelos' },
  { permission: 'fleetDist', path: '/relatorios/distdefrotas' },
  { permission: 'entraceExit', path: '/relatorios/manutencao/entradasaida' },
  { permission: 'services', path: '/relatorios/manutencao/servicos' },
  { permission: 'createSchedule', path: '/agendamentos' },
  { permission: 'scheduleList', path: '/agendamentos' },
  { permission: 'multiple', path: '/agendamentos' },
  { permission: 'callCenter', path: '/chamados' },
  { permission: 'maintenanceServices', path: '/servicos-manutencao' },
  { permission: 'fines', path: '/portal/multas' },
  { permission: 'finan', path: '/faturamento' },
  {
    permission: 'vamosControl',
    path: 'https://www.vamoscontrole.com.br/iweb2/loginvamoscontrole.aspx',
  },
  { permission: 'faq', path: '/centraldeduvidas' },
  { permission: 'crlv', path: '/gestao/veiculos' },
  { permission: 'damageCharge', path: '/gestao/cobrancas' },
  { permission: 'fines', path: '/gestao/acessoMultas' },
  { permission: 'logs', path: '/administrativo/logs' },
  { permission: 'communique', path: '/administrativo/comunicados' },
  { permission: 'access', path: '/acessos' },
];

export const getFirstAllowedPortalPath = (
  permissions: Permission[] | null | undefined,
): string | null => {
  if (!hasAnyPortalPermission(permissions)) return null;

  const match = POST_LOGIN_ROUTE_PRIORITY.find(({ permission }) =>
    hasPortalPermission(permissions, permission),
  );

  return match?.path ?? null;
};

export const getPostLoginPath = (
  permissions: Permission[] | null | undefined,
  preferredPage?: string | null,
): string => {
  if (!hasAnyPortalPermission(permissions)) return '/sem-acesso';

  if (
    preferredPage &&
    preferredPage !== '/login' &&
    preferredPage !== '/sem-acesso'
  ) {
    return preferredPage;
  }

  return getFirstAllowedPortalPath(permissions) ?? '/sem-acesso';
};
